import React from 'react';
import { GenericDetailPage } from '../../../components/generic';
import { useManagementCompany, ManagementCompany } from './useData';
import { moduleConfig, getDetailSections, getStatusBadges } from './config';

const Detail: React.FC = () => (
  <GenericDetailPage<ManagementCompany>
    useData={useManagementCompany}
    config={{
      ...moduleConfig,
      getDetailSections,
      getStatusBadges,
    }}
  />
);

export default Detail;
